// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "GothamBold";
  src: url("/fonts/gothambold_normal_normal.woff2") format("woff2");
  font-weight: 1rem;
  font-style: 1rem;
}
@font-face {
  font-family: "GothamNarrowBook";
  src: url("/fonts/GothamNarrowBook_normal_condensed.woff2") format("woff2");
  font-weight: 1rem;
  font-style: 1rem;
}
.cvx-font-gotham-bold, button[mat-flat-button].cvx-button-primary, button[mat-flat-button][disabled] {
  font-family: "GothamBold", Arial, sans-serif;
}

.cvx-fon-narrow-bold {
  font-family: "GothamNarrowBold", Arial, sans-serif;
}

.cvx-font-gotham-narrow-book {
  font-family: "GothamNarrowBook", Arial, sans-serif;
}

.cvx-gothan-medium {
  font-family: "GothamMedium", Arial, sans-serif;
}

/*font-szes*/
.extraLarge {
  font-size: 1.75rem;
  /*28px*/
}

.large2 {
  font-size: 1.375rem;
  /*22px*/
}

.large {
  font-size: 1.125rem;
  /*18px*/
}

.normal {
  font-size: 1rem;
  /*16px*/
}

.medium {
  font-size: 0.875rem;
  /*14px*/
}

.small {
  font-size: 0.75rem;
  /*12px*/
}

* {
  box-sizing: border-box;
}

body,
html {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

html {
  font-size: 14px;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}
html body {
  min-height: 100%;
}

a:active {
  color: #009dd9;
}

app-root {
  display: grid;
  height: 100%;
  background-color: #ededee;
}

app-cvx-header {
  grid-area: header;
}

app-cvx-navbar {
  grid-area: nav;
}

app-cvx-main {
  grid-area: main;
}

app-cvx-aside-left {
  grid-area: aside-left;
}

app-cvx-footer {
  grid-area: footer;
  overflow: hidden !important;
}

button[mat-flat-button].cvx-button-primary {
  background-color: #0066b2;
  border-radius: 7px;
  font-size: 1em;
}

button[mat-flat-button].cvx-button-primary:hover {
  background-color: #0b2d71;
}

button[mat-flat-button][disabled] {
  background-color: #dbdcdd;
  color: #8c8f93;
  border-radius: 7px;
  font-size: 1em;
  pointer-events: none;
  cursor: default;
}

.mat-accent.mat-mdc-checkbox {
  --mdc-checkbox-selected-pressed-icon-color: colors.\$medium-blue;
  --mdc-checkbox-selected-focus-icon-color: colors.\$medium-blue;
  --mdc-checkbox-selected-hover-icon-color: colors.\$medium-blue;
  --mdc-checkbox-selected-icon-color: colors.\$medium-blue;
  --mdc-checkbox-selected-focus-state-layer-color: colors.\$medium-blue;
  --mdc-checkbox-selected-hover-state-layer-color: colors.\$medium-blue;
  --mdc-checkbox-unselected-pressed-state-layer-color: colors.\$medium-blue;
}

.mat-accent.mat-mdc-radio-button {
  --mdc-radio-selected-focus-icon-color: colors.\$medium-blue;
  --mdc-radio-selected-hover-icon-color: colors.\$medium-blue;
  --mdc-radio-selected-icon-color: colors.\$medium-blue
  --mdc-radio-selected-pressed-icon-color: colors.\$medium-blue
  --mat-radio-checked-ripple-color: colors.\$medium-blue ;
}

app-root {
  overflow: hidden;
  grid-template-rows: 100px 46px 1fr 50px;
  grid-template-columns: 420px 1fr;
  grid-template-areas: "header header" "nav nav" "aside-left main" "footer footer";
}

app-cvx-main {
  overflow: auto;
}

app-cvx-aside-left {
  overflow: auto;
}

app-cvx-aside-right {
  overflow: auto;
}

app-cvx-footer {
  overflow: auto;
}

.contentPadding {
  display: inherit;
  flex-direction: inherit;
  flex-grow: inherit;
  width: 100%;
  padding: 40px;
}

.bg-white {
  background-color: #ffffff;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.content {
  flex-wrap: wrap;
  flex-basis: 0;
  flex-grow: 1;
  padding: 10px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
